// extracted by mini-css-extract-plugin
export var container = "_8x-0";
export var icon = "_8x-1";
export var text = "_8x-2";